module.exports = __webpack_public_path__ + "img/area_3.b7e68c9b.png";